export default {
  toBottom: 'to_bottom',
  toTop: 'to_top',
  stable: 'stable'
}
